
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/impressum",
      function () {
        return require("private-next-pages/info/impressum.tsx");
      }
    ]);
  